import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import { useState } from "react";
import { GridFilterAltIcon } from "@mui/x-data-grid";

export default function TemporaryDrawer({ children }) {
  const [show, setShow] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setShow(open);
  };

  return (
    <div>
      <Button onClick={toggleDrawer(true)} endIcon={<GridFilterAltIcon />}>
        Filters
      </Button>
      <Drawer
        anchor={"left"}
        open={show}
        onClose={toggleDrawer(false)}
      >
        <Box sx={{ width: 250 }} role="presentation">
          {children}
        </Box>
      </Drawer>
    </div>
  );
}
